import { calculaValoresFrete } from '@sotran/lib-shipper';
import { Col, Form, notification, Row, Spin, Switch } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useDebouncedCallback } from 'use-debounce';

import CardAviso from '../../../../components/CardAviso';
import { SubTitle } from '../../../../components/Typography';
import {
  getDadosCalculoFreteSeparado,
  getFaixaTarifaTmov,
} from '../../../../helpers/calculaValoresLote';
import { moneyConfig, tonConfig } from '../../../../helpers/form';
import {
  formatarMoedaIMask,
  removeMoedaMask,
  removeThousandSeparatorMask,
} from '../../../../helpers/formatador';
import { Message, TextColor } from '../../../../styles/global';
import Calculadora from './calculadora';

function definirFaixaTarifaTmov(
  segmentacao,
  tarifaTmovClienteLista,
  valor,
  isTarifaPercentual,
  setTarifaTmov
) {
  let tarifaTmovFaixa;

  if (segmentacao === 'PJ') {
    const faixaTarifaTmov = tarifaTmovClienteLista.tarifas
      ? tarifaTmovClienteLista.tarifas
          .filter(
            item => valor >= item.valor_inicial && valor <= item.valor_final
          )
          .pop()
      : 0;

    tarifaTmovFaixa = isTarifaPercentual
      ? faixaTarifaTmov.valor_tarifa_percentual / 100
      : faixaTarifaTmov.valor_tarifa_reais_tonelada;
    setTarifaTmov(tarifaTmovFaixa);
  }
  return tarifaTmovFaixa;
}

export default function ValoresLote({
  form,
  setFreteInserido,
  freteInserido,
  currentTab,
  editingLote,
  dadosPagador,
  isMarketplace,
}) {
  const { setFieldsValue, getFieldValue, getFieldsValue } = form;
  const [tarifaTmov, setTarifaTmov] = useState(0);
  const [isTarifaPercentual, setIsTarifaPercentual] = useState(true);
  const [pedagio, setPedagio] = useState(0);
  const [icms, setIcms] = useState(0);
  const [dadosEndereco, setDadosEndereco] = useState({});
  const [descricaoProduto, setDescricaoProduto] = useState('');
  const [pedagioIncluso, setPedagioIncluso] = useState(false);
  const [tarifaTmovClienteLista, setTarifaTmovClienteLista] = useState();
  const [loadingTarifaTmov, setLoadingTarifaTmov] = useState(true);
  const [switchFretePf, setSwitchFretePf] = useState(!editingLote);

  const copiaFretePj = switchChecked => {
    if (switchChecked) {
      const { freteMotoristaPj, freteTotalPj } = getFieldsValue(true);

      setFieldsValue({
        freteMotoristaPf: freteMotoristaPj,
        freteTotalPf: freteTotalPj,
      });
    }
  };

  const calculaFretes = (value, tipo, segmentacao) => {
    let tipoCalculo = 'freteMotorista';
    let salveField = 'freteTotal';

    const valor = removeMoedaMask(value || 0);

    if (tipo !== freteInserido) setFreteInserido(tipo);

    const valorPedagio = getFieldValue('pedagio') === 1 ? 0 : pedagio;

    if (tipo !== 'motorista') {
      tipoCalculo = 'freteTotal';
      salveField = 'freteMotorista';
    }

    const tarifaTmovFaixa =
      segmentacao === 'PJ'
        ? definirFaixaTarifaTmov(
            segmentacao,
            tarifaTmovClienteLista,
            valor,
            isTarifaPercentual,
            setTarifaTmov
          )
        : tarifaTmov;

    const resultado = calculaValoresFrete(
      valor,
      tipoCalculo,
      tarifaTmovFaixa,
      isTarifaPercentual,
      0,
      valorPedagio
    );

    const resultadoFormatado = formatarMoedaIMask(resultado.toFixed(2));

    if (segmentacao === 'PJ') {
      setFieldsValue({
        [`${salveField}Pj`]: resultadoFormatado,
      });
    } else if (segmentacao === 'PF') {
      setFieldsValue({
        [`${salveField}Pf`]: resultadoFormatado,
      });
    } else {
      setFieldsValue({
        [`${salveField}Pj`]: resultadoFormatado,
        [`${salveField}Pf`]: resultadoFormatado,
      });
    }

    setTarifaTmov(tarifaTmovFaixa);
    copiaFretePj(switchFretePf);
  };

  const calculaFretesDebounced = useDebouncedCallback(calculaFretes, 300);

  const recalculaFretes = async () => {
    const {
      freteMotoristaPj,
      freteTotalPj,
      freteMotoristaPf,
      freteTotalPf,
    } = getFieldsValue(true);

    const valorFretePJ =
      freteInserido === 'motorista' ? freteMotoristaPj : freteTotalPj;
    const valorFretePF =
      freteInserido === 'motorista' ? freteMotoristaPf : freteTotalPf;

    calculaFretes(valorFretePJ, freteInserido, 'PJ');
    if (valorFretePF) {
      calculaFretes(valorFretePF, freteInserido, 'PF');
    }
  };

  const validaDadosEndereco = endereco =>
    endereco.idEstadoOrigem === dadosEndereco.idEstadoOrigem &&
    endereco.idEstadoDestino === dadosEndereco.idEstadoDestino &&
    endereco.idCidadeOrigem === dadosEndereco.idCidadeOrigem &&
    endereco.idCidadeDestino === dadosEndereco.idCidadeDestino;

  const onChangeSwitchPedagio = checked => {
    setFieldsValue({
      pedagio: checked ? 1 : 3,
    });

    recalculaFretes();
    setPedagioIncluso(checked);
  };

  const onChangeSwitchFretePf = checked => {
    setSwitchFretePf(checked);
    copiaFretePj(checked);
  };

  useEffect(() => {
    setLoadingTarifaTmov(false);
  }, [tarifaTmovClienteLista]);

  useEffect(() => {
    async function getDadosForm() {
      if (currentTab !== 3) return;
      const dadosForm = getFieldsValue(true);
      setPedagioIncluso(dadosForm.pedagio === 1);

      const {
        freteMotoristaPj,
        freteMotoristaPf,
        freteTotalPj,
        freteTotalPf,
      } = dadosForm;

      const idEstadoOrigem =
        dadosForm.estadoExpedidor || dadosForm.estadoOrigem;
      const idEstadoDestino =
        dadosForm.estadoRecebedor || dadosForm.estadoDestino;
      const idCidadeOrigem =
        dadosForm.cidadeExpedidor || dadosForm.cidadeOrigem;
      const idCidadeDestino =
        dadosForm.cidadeRecebedor || dadosForm.cidadeDestino;
      const ibgeOrigem =
        dadosForm.ibgeCidadeExpedidor || dadosForm.ibgeCidadeOrigem;
      const ibgeDestino =
        dadosForm.ibgeCidadeRecebedor || dadosForm.ibgeCidadeDestino;

      const produto = dadosForm.descricaoProduto;

      const endereco = {
        idEstadoOrigem,
        idEstadoDestino,
        idCidadeOrigem,
        idCidadeDestino,
        ibgeOrigem,
        ibgeDestino,
      };

      setDescricaoProduto(produto);
      if (validaDadosEndereco(endereco)) return;

      if (
        freteMotoristaPj === freteMotoristaPf &&
        freteTotalPj === freteTotalPf
      ) {
        onChangeSwitchFretePf(true);
      }

      setDadosEndereco(endereco);
    }

    getDadosForm();
  }, [currentTab, getFieldValue]);

  useEffect(() => {
    setLoadingTarifaTmov(true);
    async function onInit() {
      try {
        if (!dadosEndereco.idEstadoOrigem) return;

        const {
          pedagioCalculado,
          tarifaTmovCliente,
          isPercentualTmov,
          valorICMS,
        } = await getDadosCalculoFreteSeparado(
          dadosEndereco,
          dadosPagador.id_cliente_raiz
        );

        if (editingLote) {
          const valorFreteSalvo =
            freteInserido === 'motorista'
              ? getFieldValue('freteMotoristaPj')
              : getFieldValue('freteTotalPj');

          setTarifaTmov(
            getFaixaTarifaTmov(
              'PJ',
              tarifaTmovCliente,
              valorFreteSalvo,
              isPercentualTmov
            )
          );
        }

        setIsTarifaPercentual(isPercentualTmov);
        setTarifaTmovClienteLista(tarifaTmovCliente);

        if (tarifaTmovCliente.tipoTarifa === 'REAIS') {
          setIsTarifaPercentual(false);
        }

        setPedagio(Number(pedagioCalculado.toFixed(2)));
        setIcms(valorICMS / 100);
      } catch (e) {
        notification.error({
          message: 'Ops, não conseguimos encontrar valores deste cliente.',
          description:
            'Caso o problema persista, entre em contato com nosso suporte.',
        });
      } finally {
        setLoadingTarifaTmov(false);
      }
    }

    onInit();
  }, [dadosEndereco, dadosPagador]);

  useEffect(() => {
    if (editingLote) return;

    const { freteMotoristaPj, freteMotoristaPf } = getFieldsValue();

    if (freteMotoristaPj || freteMotoristaPf) recalculaFretes();
  }, [pedagio, tarifaTmov]);

  return (
    <>
      <Row gutter={12}>
        <Col span={11}>
          <Form.Item
            name="volume"
            label="Volume total em toneladas"
            rules={[
              {
                required: true,
                message: 'Por favor, insira o volume total em toneladas!',
              },
            ]}
          >
            <NumberFormat
              {...tonConfig}
              disabled={!isMarketplace}
              className="total-width"
            />
          </Form.Item>
        </Col>
        <Col span={12} offset={1}>
          <Form.Item
            name="cadencia"
            label="Cadência diária em toneladas"
            rules={[
              {
                required: true,
                message: 'Por favor, insira a cadência diária em toneladas!',
              },
              () => ({
                validator(_, value) {
                  const volume = removeThousandSeparatorMask(
                    getFieldValue('volume')
                  );
                  const cadencia = removeThousandSeparatorMask(value);

                  if (!value || volume >= cadencia) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error('A cadência não pode ser maior que o volume!')
                  );
                },
              }),
            ]}
          >
            <NumberFormat
              {...tonConfig}
              disabled={!isMarketplace}
              isAllowed={value => value.floatValue >= 0}
              className="total-width"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={11}>
          <Row gutter={12}>
            <Col span={11}>
              <Form.Item
                className="mb-5"
                name="freteMotoristaPj"
                label="Frete Motorista (PJ)"
                tooltip="A Tarifa TMOV é exibida em cima dos valores de Frete PJ."
                rules={[
                  {
                    required: true,
                    message: 'Por favor, insira o valor do frete motorista',
                  },
                ]}
              >
                <NumberFormat
                  {...moneyConfig}
                  disabled={!isMarketplace || !tarifaTmovClienteLista}
                  className="total-width"
                  onChange={event =>
                    calculaFretesDebounced(
                      event.target.value,
                      'motorista',
                      'PJ'
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12} offset={1}>
              <Form.Item
                name="freteTotalPj"
                label="Frete Total (PJ)"
                rules={[
                  {
                    required: true,
                    message: 'Por favor, insira o valor do frete total',
                  },
                ]}
              >
                <NumberFormat
                  {...moneyConfig}
                  disabled={!isMarketplace || !tarifaTmovClienteLista}
                  className="total-width"
                  onChange={event =>
                    calculaFretesDebounced(event.target.value, 'total', 'PJ')
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Message margin="-20px 0 0">
                <TextColor color="#ff0000">*</TextColor>
                &nbsp;O ICMS e demais impostos não estão sendo considerados para
                o cálculo do frete.
              </Message>
            </Col>
          </Row>
        </Col>
        <Col span={12} offset={1}>
          <Row gutter={12}>
            <Col span={11}>
              <Form.Item
                className="mb-5"
                name="freteMotoristaPf"
                label="Frete Motorista (PF)"
              >
                <NumberFormat
                  {...moneyConfig}
                  disabled={
                    !isMarketplace || switchFretePf || !tarifaTmovClienteLista
                  }
                  className="total-width"
                  onChange={event =>
                    calculaFretesDebounced(
                      event.target.value,
                      'motorista',
                      'PF'
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12} offset={1}>
              <Form.Item name="freteTotalPf" label="Frete Total (PF)">
                <NumberFormat
                  {...moneyConfig}
                  disabled={
                    !isMarketplace || switchFretePf || !tarifaTmovClienteLista
                  }
                  className="total-width"
                  onChange={event =>
                    calculaFretesDebounced(event.target.value, 'total', 'PF')
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={12} className="mt-10 mb-20">
        <Col span={11}>
          <SubTitle>
            <Switch
              checked={pedagioIncluso}
              size="small"
              onChange={onChangeSwitchPedagio}
              disabled={!pedagio || !isMarketplace || !tarifaTmovClienteLista}
            />
            &nbsp;Pedágio incluso no Frete Motorista?
          </SubTitle>
        </Col>
        <Col span={12} offset={1}>
          <SubTitle>
            <Switch
              checked={switchFretePf}
              size="small"
              onChange={onChangeSwitchFretePf}
              disabled={!isMarketplace || !tarifaTmovClienteLista}
            />
            &nbsp;Frete PF igual ao do PJ
          </SubTitle>
        </Col>
      </Row>
      {loadingTarifaTmov && (
        <Row align="middle" justify="center">
          <Spin className="center-loading-spin" message="Carregando..." />
        </Row>
      )}
      {tarifaTmovClienteLista && (
        <Calculadora
          enderecos={dadosEndereco}
          descricaoProduto={descricaoProduto}
          icms={icms * 100}
          tarifaTmov={tarifaTmov}
          tarifaTmovCliente={tarifaTmovClienteLista}
          isPercentualTmov={isTarifaPercentual}
          pedagio={pedagio}
        />
      )}

      {!tarifaTmovClienteLista && !loadingTarifaTmov && (
        <Row align="middle" justify="center">
          <CardAviso className="pt-5" title="Aviso:">
            Não foi possível carregar a calculadora, pois esse cliente não
            possui tarifas parametrizado.
          </CardAviso>
        </Row>
      )}
    </>
  );
}

ValoresLote.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
  setFreteInserido: PropTypes.func.isRequired,
  freteInserido: PropTypes.string,
  currentTab: PropTypes.number.isRequired,
  editingLote: PropTypes.bool.isRequired,
  dadosPagador: PropTypes.shape({
    cnpj: PropTypes.string,
    id: PropTypes.number,
    id_cliente_raiz: PropTypes.number,
    razao_social: PropTypes.string,
  }).isRequired,
  isMarketplace: PropTypes.bool.isRequired,
};

ValoresLote.defaultProps = {
  freteInserido: 'motorista',
};
